'use strict'

export function initInScope ($scope) {
    import ('objectFitPolyfill').then((e)=> {
        const res = window.objectFitPolyfill();
    });
}
